import React from "react";
import { Link } from "react-router-dom";
import { IGalleryData } from "../../exports/interfaces";
import calendarIcon from "../../assets/img/icons/calendar.svg";

const Album = ({ gallery }: { gallery: IGalleryData[] }) => {
  return (
    <>
      <section>
        <div className="td_height_120 td_height_lg_80" />
        <div
          className="td_section_heading td_style_1 text-center wow fadeInUp"
          data-wow-duration="1s"
          data-wow-delay="0.15s"
        >
          <h2 className="td_section_title td_fs_48 mb-0">Gallery</h2>
          <div className="td_height_120 td_height_lg_80" />
        </div>
        <div className="container">
          <div className="row td_gap_y_30">
            {gallery.map((item, index) => (
              <div className="col-lg-3" key={index}>
                <div className="td_post td_style_1">
                  <Link
                    to={`/gallery/gallery-view/${item.id}`}
                    state={{
                      id: item.id,
                    }}
                    className="td_post_thumb d-block"
                  >
                    <img
                      src={`${process.env.REACT_APP_cmsUrl}/uploads/${item.thumbnail[0]?.media?.name}`}
                      alt={item.title}
                      style={{ height: 305, objectFit: "cover", width: "100%" }}
                    />
                  </Link>

                  <div className="td_post_info" style={{ height: "165px" }}>
                    {item.date && (
                      <div className="td_post_meta td_fs_14 td_medium td_mb_20">
                        <span>
                          <img src={calendarIcon} alt="calendar icon" />
                          {item.date}
                        </span>
                      </div>
                    )}

                    <h2 className="td_post_title td_fs_24 td_medium td_mb_16">
                      <Link
                        to={`/gallery/gallery-view/${item.id}`}
                        state={{
                          id: item.id,
                        }}
                      >
                        {item.title}
                      </Link>
                    </h2>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="td_height_120 td_height_lg_80" />
      </section>
    </>
  );
};

export default Album;
